import { render, staticRenderFns } from "./AngleSelect.vue?vue&type=template&id=959c487a&"
import script from "./AngleSelect.vue?vue&type=script&lang=js&"
export * from "./AngleSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("I:\\web-project\\dream\\tools\\dsf-product-ppt\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('959c487a')) {
      api.createRecord('959c487a', component.options)
    } else {
      api.reload('959c487a', component.options)
    }
    module.hot.accept("./AngleSelect.vue?vue&type=template&id=959c487a&", function () {
      api.rerender('959c487a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "pc/utils/angleSelect/AngleSelect.vue"
export default component.exports